import type { ApiUsageTranslations } from '../interfaces/apiUsage';

export const apiUsageTranslations: ApiUsageTranslations = {
  page_title: 'Uso da API',
  page_description:
    'Chamadas feitas com API keys, detalhadas por recurso e período.',

  window_7d: '7 dias',
  window_30d: '30 dias',
  window_90d: '90 dias',

  granularity_label: 'Agrupar por',
  granularity_hour: 'Hora',
  granularity_day: 'Dia',
  granularity_week: 'Semana',
  granularity_month: 'Mês',

  filter_all_resources: 'Todos os recursos',
  filter_all_keys: 'Todas as API keys',
  filter_resource_aria: 'Filtrar por recurso',
  filter_key_aria: 'Filtrar por API key',

  kpi_total_calls: 'Chamadas totais',
  kpi_total_calls_sub: 'janela atual',
  kpi_errors: 'Erros',
  kpi_error_rate: 'Taxa de erro',
  kpi_error_rate_sub: 'respostas ≥ 400',
  kpi_avg_latency: 'Latência média',
  kpi_p95_latency: 'Latência p95',
  kpi_latency_sub: 'tempo de resposta',

  chart_title: 'Chamadas ao longo do tempo',
  chart_sub: 'Total de chamadas por período',
  chart_legend_calls: 'Chamadas',
  chart_legend_errors: 'Erros',
  chart_empty: 'Sem chamadas na janela selecionada.',

  table_title: 'Detalhe por recurso e API key',
  table_sub: 'Ordenado por número de chamadas',
  col_resource: 'Recurso',
  col_api_key: 'API key',
  col_calls: 'Chamadas',
  col_errors: 'Erros',
  col_error_rate: 'Taxa erro',
  col_avg_latency: 'Média (ms)',
  col_p95_latency: 'p95 (ms)',

  unknown_key: 'Desconhecida',

  empty_title: 'Sem dados de uso',
  empty_description:
    'Ainda não foram registradas chamadas com API key neste período.',
  error_title: 'Não foi possível carregar o uso da API',
  retry: 'Tentar novamente',
};
